<template>
    <v-dialog
      v-model="mostrar"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Aplicar Color
        </v-card-title>

        <v-card-text>
          <v-radio-group v-model="color_seleccionado" row>
            <v-radio label="Ninguno" value="0" color="grey"></v-radio>
            <v-radio :label="color.nombre" v-for="color in colores" :key="color.id" :value="color.id" :color="color.valor"></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="blue darken-1" @click="mostrar = false">Cancelar</v-btn>
          <v-btn
            color="green darken-2"
            dark
            @click="aplicar"
          >
            <v-icon>done</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
export default {
    data:()=>({
        mostrar:false,
        registro:null,
        colores:[],
        color_seleccionado:null
    }),
    beforeDestroy() {
      Event.$off('abrir_seleccionar_color');
    },
    mounted(){
        Event.$on('abrir_seleccionar_color',async (registro)=>{
            console.log('registro a aplicar color',registro);
            this.registro = registro;
            if(registro.color == null){
              this.color_seleccionado = "0";
            }else{
              this.color_seleccionado = registro.color.id;
            }
            await this.cargarColores();
            this.mostrar = true;
        });
    },
    methods: {
        async aplicar(){
          let url = `${this.base_url}resultados/${this.registro.id_registro}`;
          let body = {
            colores_id:this.color_seleccionado
          };
          await this.axios.put(url,body,this.headers).then((response)=>{
            console.log('color_actualizado',response);
            this.limpiar();
             Event.$emit('cambiar_color',response.data.data);
          }).catch((error)=>{
            console.log('error',error);
            this.limpiar();
          });
          console.log('color_id',this.color_seleccionado);
        },
        async cargarColores(){
          //this.mostrarLoading('Cargando Colores...')
            this.mostrarLoading({titulo:'Cargando Colores...',color:'green'})
          
            let url = `${this.base_url}color`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.colores = response.data.data;
                console.log('colores',this.colores);
                this.ocultarLoading();
            }).catch((error)=>{
              console.log('error',error);
                this.ocultarLoading();
            });
        },
        limpiar(){
          this.mostrar = false;
          this.registro = null;
          this.colores = [];
          this.color_seleccionado = null;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
}
</script>